"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("./hooks");
/**
 * Resolves a component from BlueBase context, and returns it.
 * It is possible to pass multiple keys as backup. So if one component
 * is not found, the function will fallback and try to find next component.
 *
 * @param keys
 */
function getComponent(...keys) {
    if (keys.length === 0) {
        throw Error('getComponent method needs at least one key');
    }
    const displayName = keys.join('_');
    const BlueBaseComponent = (props) => {
        const BB = hooks_1.useBlueBase();
        // If there is no BlueBase context, throw an Error
        if (!BB) {
            throw Error(
            // eslint-disable-next-line max-len
            `Could not resolve component "${displayName}" in "getComponent" command. Reason: BlueBase context not found.`);
        }
        return react_1.default.createElement(BB.Components.resolveFromCache(...keys), props);
    };
    BlueBaseComponent.displayName = displayName;
    return BlueBaseComponent;
}
exports.getComponent = getComponent;
